// Generated by scripts/write-build-info.mjs before frontend builds.
// Do not edit by hand.
export const buildInfo = {
  commit: 'unknown',
  branch: 'unknown',
  builtAt: '2026-09-29T19:02:44.195Z',
};
